import { formatCurrency } from '@/lib/helpers/format-currency';
import { Trophy } from 'lucide-react';
import { referralAvatarColor, referralInitials } from '../utils';

interface LeaderboardCardProps {
  vendorName: string;
  totalReferrals: number;
  totalEarnings: number;
}

export const LeaderboardCard = ({
  vendorName,
  totalReferrals,
  totalEarnings,
}: LeaderboardCardProps) => {
  const board = [
    {
      rank: 4,
      name: vendorName,
      sub: `${totalReferrals} friends · you`,
      earned: totalEarnings,
      kind: 'you',
      you: true,
    },
  ];

  return (
    <div className="lb-card">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          marginBottom: 14,
        }}
      >
        <Trophy className="size-5 text-[#D9A625]" fill="#D9A625" />
        <div style={{ flex: 1 }}>
          <h3 className="rne-h3" style={{ fontSize: 15 }}>
            Top referrers this week
          </h3>
          <div className="rne-meta" style={{ fontSize: 12 }}>
            Resets every Monday
          </div>
        </div>
      </div>
      {board.map((row) => (
        <div
          key={row.rank}
          className={`lb-row ${row.kind}${row.you ? ' you' : ''}`}
        >
          <span className="rank">{row.rank}</span>
          <div
            className="av av-32"
            style={{ background: referralAvatarColor(row.name) }}
          >
            {referralInitials(row.name)}
          </div>
          <div className="nm">
            <strong>
              {row.name}
              {row.you && <span className="you-tag">YOU</span>}
            </strong>
            <div className="sub">{row.sub}</div>
          </div>
          <span className="ear">{formatCurrency(row.earned)}</span>
        </div>
      ))}
    </div>
  );
};
